<template>
  <div class="cx-divide-container">
    <el-checkbox v-model="configData.showDivide">显示分隔符</el-checkbox>
    <div class="content-item mt12" v-if="configData.showDivide">
      <cx-slider label="类型" :value.sync="configData.divideType" :options="divideTypeOptions" />
      <div class="mt12" v-if="configData.divideType === 'custom'">
        <img-icon-upload 
          :imgSrc.sync="iconSrc" 
          :iconType.sync="iconType" 
          :iconColor.sync="iconColor"
          :resInfo.sync="resInfo" />
        <div class="verticallyCenter mt12" v-if="configData.divideIconType !== 'img'">
          <span class="mr16 fs14">颜色</span>
          <cx-color-picker class="flex1" :isThemeColor.sync="configData.divideIconColorIsThemeColor"
            :colorArr.sync="configData.divideIconColor">
          </cx-color-picker>
        </div>
      </div>
      <div class="mt12" v-else>
        <div class="verticallyCenter">
          <span class="mr16 fs14">颜色</span>
          <cx-color-picker class="flex1" :isThemeColor.sync="configData.iconColorIsThemeColor" :colorArr.sync="configData.divideIconColor">
          </cx-color-picker>
        </div>
      </div>
      <div class="verticallyCenter mt12">
        <span class="mr16 fs14">尺寸</span>
        <div class="verticallyCenter mr16 flex1">
          <single-input class="input-size" placeholder="-" :value.sync="configData.divideWidth" :min="1" inputSuffixs="宽" />
        </div>
        <div class="verticallyCenter flex1">
          <single-input class="input-size" placeholder="-" :value.sync="configData.divideHeight" :min="1" inputSuffixs="高" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { produce } from "immer";
import complexSetMixin from "./complexSetMixin.js"
import publicData from "@/modules/mixins/publicData.js"
export default {
  components: {},
  mixins: [publicData, complexSetMixin()],
  name: "cxDivide",
  props: {
    defaultValue: undefined,
    config: undefined
  },
  data() {
    return {
      this1: this,
      tooltipDelay: 1000,
      divideTypeOptions: [
        {
          value: "line",
          title: "竖线",
        },
        {
          value: "custom",
          title: "自定义",
        },
      ],
    }
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    iconSrc: {
      get() {
        return this.configData.divideIconSrc
      },
      set(newVal) {
        const tempIconType = this.tempIconType
        this.tempIconSrc = newVal
        this.configData = produce(this.configData, draft => {
          draft.divideIconSrc = newVal
          draft.divideIconType= tempIconType
        })
      }
    },
    iconType: {
      get() {
        return this.configData.divideIconType
      },
      set(newVal) {
        this.tempIconType = newVal
        this.configData = produce(this.configData, draft => {
          draft.divideIconType = newVal
        })
      }
    },
    iconColor: {
      get() {
        return this.configData.divideIconColor
      },
      set(newVal) {
        this.configData = {...this.configData, divideIconColor: newVal}
      }
    },
    resInfo: {
      get() {
        return this.configData.divideResInfo
      },
      set(newVal) {
        const tempIconSrc = this.tempIconSrc
        const tempIconType = this.tempIconType
        this.configData = produce(this.configData, draft => {
          draft.divideResInfo = newVal
          draft.divideIconSrc = tempIconSrc
          draft.divideIconType = tempIconType
        })
      }
    },
  },
  methods: {
    
  }
}
</script>

<style scoped lang="scss">
::v-deep .cx_style .text_color_in_input {
  width: calc(100% - 30px);
}

.border-property {
  width: calc(100% - 108px);
}

.color-picker-wrap {
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 36px);
}

.border-select {
  position: relative;
  width: 92px;
  height: 92px;
  margin-right: 16px;

  .border-item {
    cursor: pointer;

    &.active {
      background-color: var(--themeColorSelectBg);

      i,
      i::before {
        border-color: var(--themeColor);
      }
    }
  }

  .cx-border {
    display: inline-block;
    width: 28px;
    height: 28px;
    padding: 5px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 4px;

    i,
    i::before {
      border-color: var(--subTextColor);
    }

    &:not(.active):hover {
      background: rgba(31, 35, 41, 0.08);
    }
  }

  .border-item {
    position: absolute;
  }

  .item-top {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .item-bottom {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .item-right {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .item-left {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .item-all {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.selected-icon {
  position: absolute;
  top: 50%;
  left: 8px;
  font-size: 14px;
  color: var(--themeColor);
  transform: translateY(-50%);
}

.border-style {
  display: inline-block;
  width: 26px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
  background-position: left center;
  background-clip: content-box;
}

.cx-border-all,
.cx-border-all::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
}

.cx-border-all::before {
  content: "";
  position: absolute;
  border: 2px solid;
  bottom: 0;
  left: 0;
}

.cx-border-top,
.cx-border-top::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-top: 2px solid;
}

.cx-border-top::before {
  content: "";
  position: absolute;
  height: 14px;
  border: 2px solid;
  border-top: 0;
  top: 2px;
  left: 0;
  opacity: 0.3;
}

.cx-border-bottom,
.cx-border-bottom::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-bottom: 2px solid;
}

.cx-border-bottom::before {
  content: "";
  position: absolute;
  height: 14px;
  border: 2px solid;
  border-bottom: 0;
  bottom: 2px;
  left: 0;
  opacity: 0.3;
}

.cx-border-left,
.cx-border-left::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-left: 2px solid;
}

.cx-border-left::before {
  content: "";
  position: absolute;
  width: 14px;
  border: 2px solid;
  border-left: 0;
  bottom: 0;
  left: 2px;
  opacity: 0.3;
}

.cx-border-right,
.cx-border-right::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-right: 2px solid;
}

.cx-border-right::before {
  content: "";
  position: absolute;
  width: 14px;
  border: 2px solid;
  border-right: 0;
  bottom: 0;
  right: 2px;
  opacity: 0.3;
}

::v-deep .color-picker-container .color-text {
  width: calc(100% - 58px);
  left: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .color-picker-container:hover .color-text {
  min-width: unset;
}

.set-item-28 ::v-deep.el-input .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding: 4px 0 4px 12px;
}

.set-item-28 ::v-deep.el-select .el-input__suffix-inner {
  line-height: 28px;
}

.set-item-28 ::v-deep.number-input-box .suffix_text {
  line-height: 28px;
}

.set-item-28 ::v-deep.el-input-group__append .icon-portal-arrows-up {
  margin-bottom: 0;
}

.set-item-28 ::v-deep.suffix_text {
  line-height: 28px;
}

.set-item-28 ::v-deep.el-input-group__append .icon-arrows-bg {
  height: 13px;
}

.set-item-28 ::v-deep.color-picker-container {
  height: 28px;
  padding: 4px;
}

.set-item-28 ::v-deep.color-picker-container .color-text {
  top: 4px;
}

.set-item-28 ::v-deep.color-picker-container .right-handle-icon {
  right: 4px;
  top: 2px;
}

.select-border .el-select-dropdown__item.selected {
  color: var(--subTextColor) !important;
}
</style>
